var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Head, usePage } from '@inertiajs/react';
import useTypedPage from "@/Hooks/useTypedPage";
import axios from 'axios';
import JetBanner from "@/Jetstream/Banner";
import { router } from "@inertiajs/react";
import { Toaster } from "@/components/ui/toaster";
import { useToast } from "@/components/ui/use-toast";
import { ToastAction } from "@/components/ui/toast";
import OvformLogo from "@/Jetstream/OvformLogo";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
}
export default function FrontendBookingLayout(_a) {
    var title = _a.title, renderHeader = _a.renderHeader, children = _a.children;
    var route = useRoute(Ziggy);
    var page = useTypedPage();
    var _b = useState(false), showingNavigationDropdown = _b[0], setShowingNavigationDropdown = _b[1];
    function switchToTeam(e, team) {
        e.preventDefault();
        router.put(route('current-team.update'), {
            team_id: team.id,
        }, {
            preserveState: false,
        });
    }
    function logout(e) {
        e.preventDefault();
        axios.post(route('logout')).then(function () {
            window.location.href = "/";
        });
    }
    function openTawk() {
        var _a, _b;
        if (!((_a = getCookie('__cookie_consent')) === null || _a === void 0 ? void 0 : _a.match('2'))) {
            window.toggleModalSettings();
        }
        else {
            window.Tawk_API = window.Tawk_API || {};
            if (!window.Tawk_API.onLoaded) {
                var div = document.createElement("div");
                div.setAttribute("style", "background: rgba(0,0,0,0.2); position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 99999");
                div.id = "ovform-tawk-overlay";
                document.body.appendChild(div);
                window.Tawk_API.onBeforeLoad = function () {
                    setTimeout(function () {
                        var _a;
                        (_a = document.getElementById("ovform-tawk-overlay")) === null || _a === void 0 ? void 0 : _a.remove();
                    }, 1000);
                    // remove element from dom
                    // div.setAttribute("style", "display: none");
                    window.Tawk_API.maximize();
                };
                var s1 = document.createElement("script");
                var s0 = document.getElementsByTagName("script")[0];
                s1.async = true;
                s1.src = 'https://embed.tawk.to/620d21001ffac05b1d7a3745/1fs1khqi2';
                s1.charset = 'UTF-8';
                s1.setAttribute('crossorigin', '*');
                (_b = s0.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(s1, s0);
            }
            else {
                // document.getElementById("ovform-tawk-overlay")?.remove();
                // div.setAttribute("style", "display: none");
                window.Tawk_API.maximize();
            }
        }
    }
    function getCookie(key) {
        if (!key)
            return null;
        return (decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null);
    }
    var stepIdx = 0;
    var toast = useToast().toast;
    var props = usePage().props;
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        var style = ((_a = props.toast) === null || _a === void 0 ? void 0 : _a.style) || 'success';
        var toastTitle = ((_b = props.toast) === null || _b === void 0 ? void 0 : _b.title) || null;
        var toastDescription = ((_c = props.toast) === null || _c === void 0 ? void 0 : _c.description) || null;
        var toastActionUrl = ((_d = props.toast) === null || _d === void 0 ? void 0 : _d.action_url) || null;
        var toastActionText = ((_e = props.toast) === null || _e === void 0 ? void 0 : _e.action_text) || null;
        function toastAction() {
            axios.post(toastActionUrl).then(function () {
                router.reload();
            });
        }
        if (toastTitle) {
            var toastOpts = {
                title: toastTitle,
                description: toastDescription,
            };
            if (toastActionUrl) {
                toastOpts.action = _jsx(ToastAction, __assign({ onClick: toastAction, altText: toastActionText }, { children: toastActionText }));
            }
            toast(toastOpts);
        }
    }, [props.toast]);
    return (_jsxs("div", __assign({ className: "min-h-screen flex flex-col bg-gray-100" }, { children: [_jsx(Toaster, {}), _jsx(Head, { title: title ? "OVForm \u203A ".concat(title) : 'OVForm' }), _jsx(JetBanner, {}), _jsx("main", __assign({ className: "flex-grow" }, { children: children })), _jsx("div", __assign({ className: "flex justify-center p-4 pt-12" }, { children: _jsxs("div", __assign({ className: "text-gray-400 flex items-center" }, { children: ["Powered by ", _jsx(OvformLogo, { className: "ml-2 h-8 -mt-2", fill: "rgb(156, 163, 175)" })] })) }))] })));
}
